import { native } from '@forest/native-services'
import { type Failure, withFailure } from '@forest/paywall-core'
import { isHTTPError } from 'ky'
import { m } from '~/paraglide/messages'
import { dialog } from '~/store/dialog'
import { api } from '~/services/api'

/**
 * A subscription conflict: another Forest account owns the subscription. Names
 * that account, or — when it is deleted or unknown — sends the user to manage
 * the store subscription.
 */
export async function showSubscriptionConflictDialog(
  ownerUid: number | null,
  failure: Failure,
) {
  const showDeletedAccountDialog = () =>
    dialog.open({
      title: m.dialog_subscription_link_delete_account_title(),
      description: withFailure(
        m.dialog_subscription_link_delete_account_content(),
        failure,
      ),
      button: m.btn_subscription_management(),
      action: () =>
        native.general.openURL(
          'forestapp://instant/system_subscription_management',
        ),
    })
  if (ownerUid === null) {
    showDeletedAccountDialog()
    return
  }
  let userName = ''
  let userEmail = ''
  try {
    const info = await api.service
      .get(`user/users/${ownerUid}/info`)
      .json<{ name: string; email: string }>()
    userName = info.name
    userEmail = info.email
  } catch (e) {
    if (isHTTPError(e) && e.response.status === 404) {
      showDeletedAccountDialog()
      return
    }
  }
  dialog.open({
    title: m.dialog_subscription_conflict_title(),
    description: withFailure(
      m.dialog_subscription_conflict_content({
        user_name: userName,
        user_account: userEmail,
      }),
      failure,
    ),
    button: m.OK(),
  })
}
